// extracted by mini-css-extract-plugin
export default {"menu-root":"Menu_menu-root__sB2eK","menu":"Menu_menu__uDNzY","menu-expanded":"Menu_menu-expanded__Z-T1k"};